import BMRecommendationRule from './BMRecommendationRule';

class DiscontinueRecommendationRule extends BMRecommendationRule {
    getIsRuleMet(studentResults) {
        const { measure: measureRule } = this.rule;
        return studentResults.some(
            ({ measure, isDiscontinueRuleMet, isValid }) =>
                measure === measureRule && isDiscontinueRuleMet && isValid,
        );
    }
}

export default DiscontinueRecommendationRule;
